<template>
  <div class="container">
    <house-header @update-city-select="isShowCitySelect = $event" :tradeType="tradeType" :estateName="estateName"
      :logoLineTabShow="logoLineTabShow" :logoLineTabChoose="logoLineTabChoose"
      @choose_logoLineTab="choose_logoLineTab_FN" @handle-submit="handleSubmit" @update-estate="estateName = $event"
      @update-search="updateSearch" />
    <div class="content">
      <search-bar :items="params" :updateChildren="updateChildren" @sendParamsEmit="onRefresh"
        @update-children="updateChildren = $event" />
      <div class="flex sb_start" style="margin-top:26px">
        <div class="left-content ">
          <ul v-if="tradeType == 4" class="sort-wrap flex" :style="{ borderColor: companyConfig.themeColor }">
            <li v-for="(item, index) in sort" :key="`sort_${index}_${item.name}`"
              :class="{ white: choose === item.name, greenBG: choose === item.name }" @click="setChoose(item)"
              class="flex c_center cursor ellipsis">
              <span class="size15 bold">{{ item.name }}</span>
            </li>
          </ul>
          <ul v-if="tradeType == 2" class="sort-wrap flex" :style="{ borderColor: companyConfig.themeColor }">
            <li v-for="(item, index) in sort" :key="`sort_${index}_${item.name}`"
              :class="[choose == item.name ? 'white' : '', choose == item.name ? 'greenBG' : '']"
              @click="setChoose_tradeType2(item)" class="flex c_center cursor ellipsis">
              <span class="size15 bold">{{ item.name }}</span>
              <i class="size18 ml5" :class="item.type == 'asc' ? 'el-icon-bottom' : 'el-icon-top'"
                v-show="item.type && choose == item.name"></i>
            </li>
          </ul>
          <div v-show="tradeType === 1">
            <div class="content-title flex sb_center">
              <h2 class="bold">
                已为您找到 <span class="green">{{ total }}</span> 套
                <a href="javascript:;" @click="handleScrollTop" class="black">{{ location.cityName + title }}</a>
              </h2>
              <h2 class=" bold" v-show="loading">
                正在加载房源
              </h2>
              <ul class="flex size12 black search-wrap">
                <li class="cursor pr20" @click="handleClear" v-show="!loading">
                  <i class="el-icon-delete size14 pr5"></i>
                  <span style="font-weight: 400;">清空条件</span>
                </li>
              </ul>
            </div>
          </div>
          <ul v-if="tradeType === 1" class="rent-sort-wrap flex">
            <li v-for="(item, index) in sort" :key="`rent_sort_${index}_${item.name}`"
              :style="{ borderColor: companyConfig.themeColor }" :class="{ active: choose === item.name }"
              @click="setChoose(item)" class="flex c_center cursor ellipsis">
              <span class="size15 bold">{{ item.name }}</span>
            </li>
          </ul>
          <div v-show="(tradeType == 2 && logoLineTabChoose == 1) || tradeType == 4" class="result-des flex sb_center">
            <h2 class="size22 bold" v-show="!loading && total != 0">
              共找到 <span class="green">{{ total }}</span> 套
              <router-link :to="path" class="black">{{ location.cityName + title }}</router-link>
            </h2>
            <h2 class="size22 bold" v-show="loading">
              正在加载房源
            </h2>
            <ul class="flex size12 black search-wrap">
              <li class="cursor pr20" @click="handleClear">
                <i class="el-icon-delete size14 pr5"></i>
                <span>清空条件</span>
              </li>
              <li v-if="tradeType === 2" class="cursor" @click="handleSaveSearch">
                <i class="el-icon-star-off size14 pr5"></i>
                <span>保存搜索</span>
              </li>
            </ul>
          </div>
          <div v-if="house.length">
            <ul v-if="tradeType === 4">
              <village-item v-for="(item, index) in house" :key="getUniqueKey(item, index)" :tradeType="tradeType"
                :houseItem="item" />
            </ul>
            <ul v-else-if="logoLineTabChoose == 2">
              <house-item-deal v-for="(item, index) in house" :key="getUniqueKey(item, index)" :tradeType="tradeType"
                :houseItem="item" />
            </ul>
            <ul v-else>
              <house-item v-for="(item, index) in topHouse" :key="getUniqueKey(item, index, 'top')"
                :tradeType="tradeType" :houseItem="item" />
              <house-item v-for="(item, index) in house" :key="getUniqueKey(item, index)" :tradeType="tradeType"
                :houseItem="item" @delAd="delAdFn" />
            </ul>
          </div>
          <div v-else>
            <el-empty :description="start ? emptyText : '房源加载中···'"></el-empty>
          </div>
          <div style="padding:30px 0" class="flex size12 sb_center pagination-wrap">
            <span class="flex ">
              <router-link to="/" class="col66 pr10">{{ location.cityName + ' ' }} ></router-link>
              <a href="javascript:;" @click="handleScrollTop" class="col66">{{ location.cityName + title }}</a>
            </span>
            <el-pagination :current-page="currentPage" v-if="total > 1" background layout="pager" :page-size="25"
              @current-change="handleCurrentChange" :total="total">
            </el-pagination>
          </div>
        </div>
        <div v-if="tradeType === 2" class="right-layout">
          <div class="map-room column c_center">
            <img src="@/assets/imgs/app_icon_map_room.png" alt="" />
            <router-link to="/map" class="button greenBG" target="_blank">试试地图找房</router-link>
          </div>
          <div class="sider-kandian" v-if="highlightList.length">
            <div class="flex sb_center black size16 bold">
              <span>看点</span>
              <router-link to="/kandian" class="col66 size14" target="_blank">更多</router-link>
            </div>
            <ul>
              <li v-for="(item, index) in highlightList" :key="`highlight_${item.guid || index}`"
                class="pt20 size12 flex sb_center">
                <router-link :to="{ path: `/detail/${item.guid}` }" target="_blank" class="black ellipsis"
                  style="max-width:90%">{{ item.title }}</router-link>
                <i class="el-icon-arrow-right black size14"></i>
              </li>
            </ul>
          </div>
          <div v-if="!isSourceERP" class="down-load-app" :class="[fixedDownload ? 'fixed-download ' : '']">
            <span class="bold size16 black">下载{{ companyConfig.firstName + companyConfig.lastName }}APP</span>
            <div class="qr-code">
              <img width="94" height="94" :src="downloadUrl" alt="" />
              <div class="size12 black ">
                <p>扫描上方二维码</p>
                <p>随时查看新房源</p>
                <p class="flex s_center">
                  <router-link class="colaa" to="/">了解更多</router-link>
                  <i class="el-icon-arrow-right colaa size14"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tradeType === 1 && !isSourceERP" class="right-layout">
          <div class="down-load-app column c_center">
            <div class="qr-code">
              <img width="94" height="94" :src="downloadUrl" alt="" />
              <div class="size12 black " :class="[tradeType === 1 ? '' : 'mt20']">
                <p class="bold size16 black">下载{{ companyConfig.firstName }}APP</p>
                <p>扫描上方二维码</p>
                <p>随时查看新房源</p>
                <p class="flex s_center">
                  <router-link class="colaa" to="/">了解更多</router-link>
                  <i class="el-icon-arrow-right colaa size14"></i>
                </p>
              </div>
            </div>
          </div>
          <div style="padding:0;border:none">
            <p class="mb20 bold size20">热推房源</p>
            <ul>
              <recommend-rent-house v-for="(houseItem, index) in recommendRentHosue"
                :key="`rent_${houseItem.guid || index}`" :houseItem="houseItem" />
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="recommend-estate" v-if="recommendList.length && tradeType === 2">
      <div class="content">
        <h3 class="black size24 bold" style="padding-top:46px">推荐楼盘</h3>
        <ul style="padding:23px 0 46px" class="flex sb_start">
          <estate-item v-for="(estate, index) in recommendList" :estate-item="estate"
            :key="`estate_${estate.guid || index}`" />
        </ul>
      </div>
    </div>
    <save-ok :show-save-ok="showSaveOk" @update-save-ok="showSaveOk = $event" />
    <city-select :show-city-select="isShowCitySelect" @update-city-select="isShowCitySelect = $event" />
  </div>
</template>

<script>
import CitySelect from "@/components/city-select";
import HouseHeader from "@/components/house-header";
import SearchBar from "@/components/search-bar";
import HouseItem from "./components/house-item";
import HouseItemDeal from "./components/house-item-deal";
import EstateItem from "./components/estate-item";
import RecommendRentHouse from "./components/recommend-rent-house";
import VillageItem from "./components/village-item";
import houseServer from "@/services/houseServer.js";
import SaveOk from "./components/save-ok";
import util from "@/utils/util";
import tool from "@/utils/tool";
import { mapState } from "vuex";
import { getItem, setItem } from '../../utils/storage'
import Constant from "@/common/Constant";
let that;
export default {
  name: "house",
  props: {},
  data() {
    return {
      tradeType: 2,
      params: [],
      loading: false,
      searchParams: {
        page: 1,
        itemsPerPage: 25,
        estateName: ""
      },
      estateName: "",
      choose: "默认",
      total: 0,
      house: [],
      sort: [],
      recommendList: [],
      recommendRentHosue: [], // 推荐租房
      highlightList: [] /* 看点 */,
      fixedDownload: false,
      title: "二手房",
      emptyText: "",
      isLoadParams: false, //是否加载搜索参数
      showSaveOk: false,
      isWrite: false, //搜索记录过来
      updateChildren: false, //是否更新子组件
      currentPage: 1,
      start: false,
      topHouse: [],
      isShowCitySelect: false,
      logoLineTabShow: false, // 导航栏中的logoLineTabBox是否显示
      logoLineTabChoose: 1, // 导航栏中的logoLineTabBox的选中状态 1是出售 2是成交
    };
  },
  computed: {
    ...mapState(["location", "isGetLocation", "cityCompany", "searchRecords", "companyConfig", "isSourceERP", "user"]),
    path() {
      return `/house/${this.tradeType}`;
    },
    downloadUrl() {
      return this.companyConfig.downloadUrl
    }
  },
  components: {
    HouseHeader,
    SearchBar,
    HouseItem,
    HouseItemDeal,
    EstateItem,
    RecommendRentHouse,
    VillageItem,
    SaveOk,
    CitySelect
  },
  watch: {
    $route: {
      handler(newVal, val) {
        if (
          !val ||
          newVal.params.tradeType !== val.params.tradeType ||
          newVal.query.estateName !== val.query.estateName
        ) {
          this.tradeType = +newVal.params.tradeType;
          const estateName = newVal.query.estateName;
          this.estateName = estateName || "";

          this.logoLineTabShow = this.tradeType == 2 ? true : false;

          this.clearHouse();
          this.searchParams = {
            page: 1,
            itemsPerPage: 25,
            estateName: this.estateName
          };
          this.isLoadParams = false;
          this.start = false
          if (this.logoLineTabChoose == 1) {
            this.loadData();
          } else {
            // 成交
            this.get_getHistoryQuery()
          }
        }
      },
      immediate: true //第一次就监听
    },
    location: {
      handler(newVal, preVal) {
        if (!preVal || newVal.cityCode !== preVal.cityCode) {
          if (this.logoLineTabChoose == 1) {
            this.loadData();
          } else {
            // 成交
            this.get_getHistoryQuery()
          }
        }
      },
      immediate: true //第一次就监听
    }
  },
  methods: {
    getUniqueKey(item, index, prefix = '') {
      // 优先使用 guid，如果没有则使用 index，可以加上 prefix 区分不同类型的列表
      return item.guid ? `${prefix}_${item.guid}` : `${prefix}_${index}`;
    },
    clearHouse() {
      this.searchParams.page = 1;
      this.house = [];
      this.recommendRentHosue = [];
      this.total = 0;
    },
    async loadTopHouse() {
      let params = {}
      params.cityCode = this.location.cityCode;
      params.tradeType = this.tradeType;
      const { data } = await houseServer.loadTopHouse(params);
      if (data) {
        this.topHouse = data.map((i) => { return { ...i, attention: false } })
      }
    },
    async loadSaleHouse(params = this.searchParams) {
      if (this.loading) return;
      try {
        this.loading = true;
        params.cityCode = this.location.cityCode;
        params.tradeType = this.tradeType;
        params.area1 = this.location.cityCode;
        const { data } = await houseServer.getHouseList(params);
        if (data) {
          const { records, total } = data;
          let arr = JSON.parse(JSON.stringify(records))
          if (params.page === 1) {
            this.total = total;
            this.recommendRentHosue = records?.slice?.(0, 5);
            if (arr.length > 0) {
              let adPosition = total < 3 ? 1 : 3;
              arr.splice(adPosition, 0, { isAd: 'Ad' });
            }
          }
          this.house = arr.map((i) => { return { ...i, attention: false } }) || [];
          if ((this.house.length > 0 || this.topHouse.length > 0) && this.user?.customer?.phone) {
            this.get_getAttentionPage()
          }
          return;
        }
        this.total = 0;
        this.recommendRentHosue = [];
        this.house = [];
      } catch (err) {
        console.log("getSaleHouse :>>", err);
      } finally {
        this.loading = false;
        this.start = true
      }
    },
    async delAdFn() {
      this.house = this.house.filter((i) => { return !i.isAd })
    },
    async get_getAttentionPage() {
      let topHouse = this.topHouse.map((i) => { return i.guid })
      let house = this.house.map((i) => { return i.guid })
      let obj = {
        houseGuids: topHouse.concat(house)
      }
      const { data } = await houseServer.getAttentionPage(obj);
      if (data.length > 0) {
        let topHouse_list = this.topHouse.map((i) => { return { ...i, attention: data.find((j) => { return j == i.guid }) ? true : false } })
        let house_list = this.house.map((i) => { return { ...i, attention: data.find((j) => { return j == i.guid }) ? true : false } })


        this.topHouse = JSON.parse(JSON.stringify(topHouse_list));
        this.house = JSON.parse(JSON.stringify(house_list))
      }
    },
    async loadSearchItems(arr) {
      const [err, res] = await tool.to(
        util.getSellSearchParams(this.tradeType, this.location.cityCode)
      );
      if (err) {
        return;
      }
      let _params = JSON.parse(JSON.stringify(res))
      if (arr) {
        _params = _params.filter((e) => {
          if (!arr.includes(e.key)) {
            return e
          }
        })
      }
      this.params = _params;
      if (this.tradeType == 2) {
        this.sort = [
          { name: '默认排序', value: 0 },
          { name: '最新发布', value: 1 },
          { name: '总价', value: 2, type: 'asc', values: [{ order: 'asc', code: 2 }, { order: 'desc', code: 3 }] },
          { name: '房屋单价', value: 4, type: 'asc', values: [{ order: 'asc', code: 4 }, { order: 'desc', code: 10 }] },
          { name: '面积', value: 11, type: 'asc', values: [{ order: 'asc', code: 11 }, { order: 'desc', code: 5 }] },
        ];
      } else {
        this.sort = res.filter(ele => ele.key === "sort")[0].data;
      }
      this.choose = this.sort[0].name;
      let temp = util.createSearchObject(this.searchParams, _params);
      const {
        query: { param }
      } = this.$route;
      // 我的搜索过来
      if (param && !this.isWrite) {
        const _params = [...this.params];
        param.forEach(_ => {
          switch (_.key) {
            case "site":
              this.isLoadParams = false;
              this.$store.commit("saveLocation", _.value);
              break;
            default:
              _params.forEach(cur => {
                if (cur.key === _.key) {
                  cur.value = _.value;
                }
                if (_.key === "city") {
                  cur.selectedData = _.selectedData;
                }
              });
          }
        });
        this.params = _params;
        util.createSearchObject(this.searchParams, _params);
        this.isWrite = true;
      }
    },
    async loadEstateParams() {
      const [err, res] = await tool.to(
        util.getEstateParams(this.location.cityCode)
      );
      if (err) {
        return;
      }
      if (res) {
        this.params = res;
        if (this.tradeType == 2) {
          this.sort = [
            { name: '默认排序', value: 0 },
            { name: '最新发布', value: 1 },
            { name: '总价', value: 2, type: 'asc', values: [{ order: 'asc', code: 2 }, { order: 'desc', code: 3 }] },
            { name: '房屋单价', value: 4, type: 'asc', values: [{ order: 'asc', code: 4 }, { order: 'desc', code: 10 }] },
            { name: '面积', value: 11, type: 'asc', values: [{ order: 'asc', code: 11 }, { order: 'desc', code: 5 }] },
          ];
        } else {
          this.sort = res.filter(ele => ele.key === "sort")[0].data;

        }
        this.choose = this.sort[0].name;
      }
    },
    async loadRecommendList() {
      const params = {
        page: 1,
        itemsPerPage: 5,
        sort: 0,
        cityCode: this.location.cityCode
      };

      const [err, result] = await tool.to(houseServer.getNewEstatePage(params));

      if (err) {
        return;
      }

      // 安全检查：确保 result 和 result.data 存在
      if (result && result.data && Array.isArray(result.data) && result.data.length) {
        this.recommendList = result.data;
      } else {
        this.recommendList = []; // 设置为空数组
      }
    },
    async loadHighlightList() {
      const params = {
        page: 1,
        itemsPerPage: 5,
        categoryGuid: "580f3e4deefc451d9fee553c1af5a74e",
        companyGuid: getItem(Constant.CITY_COMPANY)?.cityCompanyGuid || '',
        pcOrMobile: true
      };
      const [err, { data }] = await tool.to(
        houseServer.customerArticle(params)
      );
      if (err) {
        return;
      }
      if (data && data.records && data.records.length) {
        this.highlightList = data.records;
      }
    },
    async loadEstateList() {
      const params = { ...this.searchParams };
      if (this.loading) return;
      try {
        this.loading = true;
        params.cityCode = this.location.cityCode;
        const { data } = await houseServer.getEstateList(params);
        if (data) {
          const { records, total } = data;
          if (params.page === 1) {
            this.total = total;
          }
          this.house = records || [];
          return;
        }
        this.total = 0;
        this.house = [];
      } catch (err) {
        console.log("getEstateList :>>", err);
      } finally {
        this.loading = false;
        this.start = true
      }
    },
    setChoose(item) {
      if (this.choose === item.name) return;
      this.choose = item.name;
      this.searchParams.page = 1;
      this.currentPage = 1;
      this.searchParams.sort = item.value;
      if (this.logoLineTabChoose == 1) {
        this.loadData();
      } else {
        // 成交
        this.get_getHistoryQuery()
      }
    },
    setChoose_tradeType2(item) {
      this.choose = JSON.parse(JSON.stringify(item.name));
      let _sort = JSON.parse(JSON.stringify(this.sort));
      let type = 'asc';
      let value = 0;
      if (this.choose == item.name) {
        type = item.type == 'asc' ? 'desc' : 'asc'
        value = item.values.filter(ele => ele.order == type)[0].code
      }
      this.sort = _sort.map((e) => {
        return { ...e, type: e.name == item.name ? type : e.type, value: e.name == item.name ? value : e.value }
      });
      this.searchParams.sort = value;
      this.searchParams.page = 1;
      this.currentPage = 1;
      this.searchParams.sort = item.value;
      this.topHouse = []
      if (this.logoLineTabChoose == 1) {
        this.loadData();
      } else {
        // 成交
        this.get_getHistoryQuery()
      }
    },
    onRefresh({ data, isRefresh = true }) {
      this.topHouse = []
      this.params = data;
      const params =
        this.tradeType === 4
          ? util.createEstateSearchObject(this.searchParams, data)
          : util.createSearchObject(this.searchParams, data);
      this.cityName = params.cityName;
      delete params.cityName;
      this.isLoadParams = true;
      this.start = false
      this.topHouse = []
      if (isRefresh) {
        if (this.logoLineTabChoose == 1) {
          this.clearHouse();
          this.loadData();
        } else {
          // 成交
          this.clearHouse();
          this.get_getHistoryQuery()
        }
      }
    },

    async loadData() {
      await this.loadEstate()
      switch (this.tradeType) {
        case 4:
          this.loadEstateList();
          if (!this.isLoadParams) {
            this.loadEstateParams();
            this.isLoadParams = true;
          }
          break;
        default:
          if (!this.isLoadParams) {
            if (this.tradeType === 2) {
              this.loadRecommendList();
              this.loadHighlightList();
            }
            this.isLoadParams = true;
            this.loadSearchItems();
          }
          /* 防止我的搜索页面过来 */
          setTimeout(() => {
            this.loadSaleHouse();
          }, 300);
      }
      this.getText();
    },
    handleCurrentChange(page) {
      this.searchParams.page = page;
      this.currentPage = page;
      if (this.logoLineTabChoose == 1) {
        this.loadData();
      } else {
        // 成交
        this.get_getHistoryQuery()
      }
      tool.animate(window, 0);
    },
    handleScroll: tool.throttle(() => {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 1300 && scrollTop < 6000) {
        that.fixedDownload = true;
      } else if (scrollTop < 1300 || scrollTop > 6000) {
        that.fixedDownload = false;
      }
    }, 400),
    getText() {
      let title = "",
        emptyText = "";
      switch (this.tradeType) {
        case 1:
          title = "租房";
          emptyText = "当前城市暂无推荐租房,请切换城市";
          break;
        case 2:
          title = "二手房";
          emptyText = "当前城市暂无推荐二手房,请切换城市";
          break;
        default:
          title = "小区";
          emptyText = "当前城市暂无推荐小区,请切换城市";
      }
      this.title = title;
      this.emptyText = emptyText;
    },
    handleSubmit() {
      this.searchParams = {
        ...this.searchParams,
        estateName: this.estateName
      };
      this.topHouse = [];
      if (this.logoLineTabChoose == 1) {
        this.clearHouse();
        this.loadData();
      } else {
        // 成交
        this.clearHouse();
        this.get_getHistoryQuery()
      }
    },
    handleClear() {
      this.estateName = "";
      this.choose = this.sort[0]?.name || "";
      this.updateChildren = true;
      this.searchParams = {
        page: 1,
        itemsPerPage: 25,
        estateName: ""
      };
      const _params = [...this.params];
      _params.forEach(_ => {
        switch (_.type) {
          case "region":
            _.value = {};
            _.selectedData = {};
            break;
          case "range_value_input":
            _.value = [];
            _.input = {
              minValue: "",
              maxValue: ""
            };
            break;
          case "single_value_multiple":
            _.value = [];
            break;
          default:
            _.value = {};
        }
      });
      if (this.logoLineTabChoose == 1) {
        this.loadData();
      } else {
        // 成交
        this.get_getHistoryQuery()
      }
    },
    handleSaveSearch() {
      const searchRecords = [];
      searchRecords.push({
        key: "site",
        value: this.location
      });
      let flag = false;
      this.params.forEach(({ key, value, data, selectedData }) => {
        if (key !== "sort") {
          let temp;
          if (key === "city") {
            if (value.value) {
              temp = {
                value,
                key,
                selectedData
              };
            }
          } else if (value.length) {
            temp = {
              value,
              key,
              data: data.filter(_ => value.includes(_.value))
            };
          }
          if (temp) {
            searchRecords.push(temp);
            flag = true;
          }
        }
      });
      if (!flag) {
        this.$message.error("请选择筛选条件哦~");
        return;
      }
      this.$store.commit("saveSearchRecords", [
        searchRecords,
        ...this.searchRecords
      ]);
      this.showSaveOk = true;
    },
    updateSearch() {
      this.isLoadParams = false;
      this.isWrite = false;
      this.topHouse = [];
      if (this.logoLineTabChoose == 1) {
        this.loadData();
      } else {
        // 成交
        this.get_getHistoryQuery()
      }
    },
    handleScrollTop() {
      tool.animate(window, 0);
    },
    init() {
      const { query: { isSourceERP = false } } = this.$route;
      if (getItem(Constant.IS_SORCE_ERP)) return
      this.$store.commit("updateState", {
        data: !!isSourceERP,
        key: "isSourceERP"
      });
      setItem(Constant.IS_SORCE_ERP, !!isSourceERP)
    },
    async loadEstate() {
      const { query: { estateGuid } } = this.$route
      if (!estateGuid || (estateGuid && this.estateName)) return
      const { data } = await houseServer.getOldEstateInfo(estateGuid);
      this.estateName = data.name || ""
      this.searchParams.estateName = this.estateName
      this.searchParams.estateGuid = estateGuid
    },
    async get_getHistoryQuery() {
      const params = { ...this.searchParams };
      if (this.loading) return;
      try {
        this.loading = true;
        params.cityCode = this.location.cityCode;
        const { data } = await houseServer.getHistoryQuery(params);
        if (data) {
          const { records, total } = data;
          if (params.page === 1) {
            this.total = total;
          }
          this.house = records || [];
          return;
        }
        this.total = 0;
        this.house = [];
      } catch (err) {
        console.log("getEstateList :>>", err);
      } finally {
        this.loading = false;
        this.start = true
      }
    },
    choose_logoLineTab_FN(e) {
      this.logoLineTabChoose = e.value
      if (e.value == 1) {
        // 出售
        this.clearHouse();
        this.loadData();
      } else {
        // 成交
        this.clearHouse();
        this.loadSearchItems(['houseTags']);
        this.get_getHistoryQuery()
      }
    },
  },
  created() {
    that = this;
    this.logoLineTabShow = this.$route.params.tradeType == 2 ? true : false;
    this.loadTopHouse()
    this.init()
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    tool.animate(window, 0);

  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.container {
  .left-content {
    width: 910px;

    .content-title {
      font-size: 16px;
      color: #101d37;
      margin-top: 30px;
      margin-bottom: 14px;
      font-weight: 700;

      .clear {
        color: #5680a6;
        text-decoration: underline;
        font-size: 14px;
        font-weight: 400;
      }
    }

    .result-des {
      height: 55px;
      line-height: 55px;
      border-bottom: 1px solid #f1f1f1;

      a:hover {
        text-decoration: underline;
      }
    }

    .sort-wrap {
      border-bottom: 2px solid;

      li {
        width: 120px;
        height: 48px;
        box-sizing: border-box;
      }
    }

    .rent-sort-wrap {
      position: relative;
      width: 100%;
      border-bottom: 1px solid #eee;

      li {
        font-weight: 700;
        font-size: 13px;
        color: #4a4a4a;
        margin-right: 37px;
        padding-bottom: 15px;
        padding-top: 16px;
        margin-bottom: -1px;

        &.active {
          border-bottom: 2px solid;
        }
      }
    }
  }

  .right-layout {
    width: 180px;

    &>div {
      padding: 35px 0;
      border-bottom: 1px solid #eee;
    }

    .map-room {
      img {
        width: 120px;
        height: 120px;
      }

      .button {
        text-decoration: none;
        margin-top: 26px;
        display: block;
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 12px;
        line-height: 36px;
        font-weight: 700;
        cursor: pointer;
      }
    }

    .down-load-app {
      border-bottom: none;

      .qr-code {
        margin-top: 28px;

        p {
          height: 23px;
          line-height: 23px;
        }
      }
    }

    .fixed-download {
      width: 180px;
      position: fixed;
      top: 0px;
      z-index: inherit;
    }
  }

  .recommend-estate {
    background-color: #f5f5f6;
  }

  .search-wrap {
    span:hover {
      text-decoration: underline;
    }
  }
}
</style>
